<template>
  <transition name="el-zoom-in-top">
        <div class="content-wrapper">
       <!-- Content Header (Page header) -->
        <section class="content-header">
            <!-- <h1>Toko<small>It's all start from here <i class="ti-heart"></i><i class="ti-export"></i><i class="ti-printer"></i></small></h1> -->
            <ol class="breadcrumb">
                <li><router-link to="/"> <i class="ti-home"></i></router-link></li>
                <li><a href="#">Laporan</a></li>
                <li class="active">Laporan</li>
            </ol>
        </section>
  
            <!-- Main content -->
            <section class="content">
               <!-- Basic Tables-->
                <div class="box">
                    <div class="box-header with-border">
                        <div class="pull-right">
                            <el-button type="success" icon="el-icon-plus" @click="addData()">Tambah Data</el-button>                            
                        </div>
                    </div>
                    <div class="box-body">

                      <tree-table :data="data" :columns="columns" border></tree-table>

                    </div>
                  </div>
                </section>
              </div>

            </transition>

  </div>
</template>

<script>
/**
  Auth: Lei.j1ang
  Created: 2018/1/19-14:54
*/
import treeTable from '../../TreeTable'

export default {
  name: 'treeTableDemo',
  components: { treeTable },
  data: function () {
    return {
      columns: [
        {
          text: 'Event',
          value: 'event',
          width: 200
        },
        {
          text: 'ID',
          value: 'id'
        },
        {
          text: 'TimeLine',
          value: 'timeLine'
        },
        {
          text: 'Comment',
          value: 'comment'
        }
      ],
      data: [
        {
          id: 0,
          event: 'Event1',
          timeLine: 50,
          comment: ''
        },
        {
          id: 1,
          event: 'Event1',
          timeLine: 100,
          comment: '',
          children: [
            {
              id: 2,
              event: 'Event2',
              timeLine: 10,
              comment: ''
            },
            {
              id: 3,
              event: 'Event3',
              timeLine: 90,
              comment: '',
              children: [
                {
                  id: 4,
                  event: 'Event4',
                  timeLine: 5,
                  comment: ''
                },
                {
                  id: 5,
                  event: 'Event5',
                  timeLine: 10,
                  comment: ''
                },
                {
                  id: 6,
                  event: 'Event6',
                  timeLine: 75,
                  comment: '',
                  children: [
                    {
                      id: 7,
                      event: 'Event7',
                      timeLine: 50,
                      comment: '',
                      children: [
                        {
                          id: 71,
                          event: 'Event71',
                          timeLine: 25,
                          comment: 'xx'
                        },
                        {
                          id: 72,
                          event: 'Event72',
                          timeLine: 5,
                          comment: 'xx'
                        },
                        {
                          id: 73,
                          event: 'Event73',
                          timeLine: 20,
                          comment: 'xx'
                        }
                      ]
                    },
                    {
                      id: 8,
                      event: 'Event8',
                      timeLine: 25,
                      comment: ''
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// LaporanTree.vue?20dd787c